import * as React from "react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { API } from "../../assets/staticData";

export default function SelectCategory({ cat, setCat, refreshCats }) {
  const [cats, setCats] = React.useState([]);

  const handleChange = (event) => {
    setCat(event.target.value);
  };

  let userToken = localStorage.getItem("userToken");

  const headers = {
    Authorization: `Bearer ${userToken}`,
  };

  React.useEffect(() => {
    async function getData() {
      fetch(`${API}/categories`, {
        headers,
        method: "GET",
      }).then(async (res) => {
        const respone = await res.json();
        setCats(respone.data);
      });
    }

    getData();
  }, [refreshCats]);

  return (
    <FormControl sx={{ minWidth: 300, width: "90%", textAlign: "start" }} size="small">
      <Select
        value={cat}
        onChange={handleChange}
        displayEmpty
        inputProps={{ "aria-label": "Without label" }}>
        <MenuItem value="" disabled>
          Category
        </MenuItem>
        {cats &&
          cats.map((item, index) => (
            <MenuItem key={index} value={item}>
              {item?.attributes?.category}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
}
